import React from 'react';

const RESIZE_EVENT_NAME = 'resize';

const isTruncated = (targetElement: HTMLElement | null) => {
    if (targetElement) {
        return targetElement.offsetWidth < targetElement.scrollWidth;
    }

    return false;
};

export const useTruncated = (element: HTMLElement | null, deps: any[] = [], listenToResizes = false) => {
    const [truncated, setTruncated] = React.useState<boolean>(isTruncated(element));

    const updateTruncationStatus = () => {
        setTruncated(isTruncated(element));
    };

    React.useEffect(() => {
        updateTruncationStatus();

        if (listenToResizes) {
            window.addEventListener(RESIZE_EVENT_NAME, updateTruncationStatus);
            return () => window.removeEventListener(RESIZE_EVENT_NAME, updateTruncationStatus);
        }
    }, [element, ...deps]);

    return { truncated };
};
